<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw TitlePage-rw exclude-print-rw" epub:type="frontmatter titlepage" id="titlepage">
<h1 class="title"><a id="page-v"></a>Saints and Sinners</h1>
<p class="stitle"><em>Stories</em></p>
<h1 class="author">Edna O’Brien</h1>
<p class="publisher"><span><img alt="image" src="images/Art_pub.jpg"/></span></p>
<p class="city"><span>NEW YORK   BOSTON   LONDON</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?b235b5bc